// TAT countdown badge — green/amber/red based on remaining working hours.
// Doesn't do calendar math client-side; uses backend-computed tat_deadline.
export default function TatBadge({ deadline, current_stage, status }) {
  if (!deadline || status === "completed" || status === "rejected" || status === "on_hold") {
    return null;
  }
  if (!["hod_review", "admin1_review", "admin2_review"].includes(current_stage)) {
    return null;
  }
  const now = new Date();
  const dl = new Date(deadline);
  const diffMs = dl - now;
  const diffH = diffMs / 3600000;
  let cls = "bg-emerald-100 text-emerald-800 border-emerald-300";
  let label = `${diffH.toFixed(1)}h left`;
  if (diffMs <= 0) {
    cls = "bg-[#fcebe9] text-[#b3261e] border-[#b3261e]/40";
    label = `TAT breached · ${Math.abs(diffH).toFixed(1)}h ago`;
  } else if (diffH <= 1) {
    cls = "bg-orange-100 text-orange-800 border-orange-300";
    label = `TAT soon · ${diffH.toFixed(1)}h`;
  } else if (diffH <= 2) {
    cls = "bg-amber-100 text-amber-800 border-amber-300";
  }
  return (
    <span className={`badge ${cls}`} title={`TAT deadline: ${dl.toLocaleString()}`} data-testid="tat-badge">
      {label}
    </span>
  );
}
